import Fetch from 'utils/fetch';
import { settings } from 'settings';

export interface PerformanceScanByTime {
  timePart: string;
  scannedBy?: number;
  firstName: string;
  lastName: string;
  nrOfFirstScans?: number;
  totalNrOfScans?: number;
  nrOfCompletedScans?: number;
  firstScan?: string;
}

export async function fetchScanPerformanceByTime(
  startDate: string,
  endDate: string
): Promise<PerformanceScanByTime[]> {
  try {
    const response: Response = await Fetch.put({
      url: `${settings.newApiUrl}/scan/scanPerformanceByTime?start=${startDate}&end=${endDate}`,
    });

    if (response.ok) {
      const performanceScanList: PerformanceScanByTime[] =
        await response.json();
      return performanceScanList;
    }
  } catch (error) {
    return [];
  }
}
